import { getField, updateField } from 'vuex-map-fields';
import LocationSearch from '../../api/location-search';

// initial state
const state = {
    geoLocation: null,
    endOfResults: false,
    firstResults: [],
    searchResults: null,
    allSearchResults: [],
    globals: {
        apiKey: 'AIzaSyCc3pdHDNXTAQAIUBD1EmbYVNAh7k9pja8'
    }
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    getSearchResults({ commit, rootState }, { Longitude, Latitude, SearchRadius, City, State, ZipCode, ExcludeMilesAway, ClinicId, PageSize, PageNumber, dealerId, clientToken, replaceData, cb }) {
        LocationSearch.getSearchResults((data) => {
            let validRes = (
                    Object.prototype.hasOwnProperty.call(data, 'status') && Object.prototype.hasOwnProperty.call(data, 'headers') && (data.status >= 200 && data.status <= 299))
                || !(Object.prototype.hasOwnProperty.call(data, 'status') && Object.prototype.hasOwnProperty.call(data, 'headers'));

            if (validRes) {
                commit('setStateValue', { key: 'searchResults', value: data });
                let action = replaceData ? 'setStateValue' : 'appendStateValue';
                commit(action, { key: 'allSearchResults', value: data.data });
                if (state.firstResults.length === 0) {
                    commit('setStateValue', { key: 'firstResults', value: data.data });
                }
                if (data.data.length !== 8) {
                    commit('setStateValue', { key: 'endOfResults', value: true });
                }
                if (cb) {
                    cb();
                }
            } else {
                commit('setStateValue', { key: 'searchResults', value: null });
                commit('setStateValue', { key: 'allSearchResults', value: [] });
                commit('setStateValue', { key: 'firstResults', value: [] });
                commit('setStateValue', { key: 'endOfResults', value: false });
                if (cb) {
                    cb();
                }
            }
        }, { Longitude, Latitude, SearchRadius, City, State, ZipCode, ExcludeMilesAway, ClinicId, PageSize, PageNumber, dealerId, clientToken });
    },
    updateGeoLocation({ commit, rootState }, val) {
        commit('setStateValue', { key: 'geoLocation', value: val });
    },
    resetResults({ commit, rootState }) {
        commit('setStateValue', { key: 'firstResults', value: [] });
        commit('setStateValue', { key: 'allSearchResults', value: [] });
        commit('setStateValue', { key: 'endOfResults', value: false });
    }
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    },
    appendStateValue(state, payload) {
        state[payload.key].push(...payload.value);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
